<template>
  <div class="content">
    <div class="header">
      <img @click="jumpToIndex()" src="../assets/logo.png" class="logo-img" alt="" />
      <div class="b-box">
        <div class="box1">
          <img :src="logo" alt="" />
          <div>{{ `￥${price}` }}</div>
        </div>
        <div class="line"></div>
        <div>{{ `MC:￥${MC} B` }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo:"",
      price: 0,
      searchQuery: "",
      MC:0
    };
  },
  created(){
    this.getAssetDetail()
  },
  methods:{
  jumpToIndex(){
this.$router.push({ name: 'Explorer'});
  },
    getAssetDetail() {
      let params = {
        assetId:"97f4b4ba498c9e325dc8ea89480938eb",
      };
      this.$api.getAssetDetail(params).then((response) => {
        this.MC=(response.data.body.price*1).toFixed(2)||0
        this.price=(response.data.body.price).toFixed(2)
        this.logo=response.data.body.logo
      }).catch(error=>{

      });
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 18px 0;
}
.header {
  display: flex;
  align-items: center;
  background-color: #fff;
  max-width: 1400px;
  width: 1400px;
  .logo-img {
    width: 120px;
    margin-right: 12px;
    cursor: pointer;
  }
  .b-box {
    display: flex;
    align-items: center;
    background-color: #f2f2f2;
    border-radius: 12px;
    font-size: 15px;
    line-height: 22px;
    font-weight: 400;
    padding: 4px 8px;
    color: #000;
    .line{
      height: 14px;
      width: 1px;
      background-color: #000;
      margin: 0 8px;
    }
    .box1 {
      display: flex;
      align-items: center;
      img {
        width: 15px;
        margin-right: 6px;
        // margin-top: -2px;
      }
    }
  }
}
</style>
